import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Trash2, Mail, CheckCircle, XCircle } from 'lucide-react';
import { subscribeApi } from '../../utils/api';

function AdminSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    setLoading(true);
    try {
      const response = await subscribeApi.getAll();
      setSubscribers(response.data);
    } catch (error) {
      console.error('Error fetching subscribers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActive = async (email) => {
    try {
      await subscribeApi.toggleActive(email);
      toast.success('सब्स्क्राइबर स्थिति परिवर्तन भयो।');
      await fetchSubscribers();
    } catch (error) {
      console.error('Error toggling subscriber:', error);
      toast.error('स्थिति परिवर्तन गर्न असफल भयो।');
    }
  };

  const handleDelete = async (email) => {
    if (!window.confirm('के तपाईं यो सब्स्क्राइबर मेटाउन निश्चित हुनुहुन्छ?')) return;
    try {
      await subscribeApi.delete(email);
      toast.success('सब्स्क्राइबर मेटियो।');
      await fetchSubscribers();
    } catch (error) {
      console.error('Error deleting subscriber:', error);
      toast.error('सब्स्क्राइबर मेटाउन असफल भयो।');
    }
  };

  if (loading) {
    return <div className="text-center py-16 text-muted">लोड हुँदै...</div>;
  }

  const stats = [
    { label: 'कुल सब्स्क्राइबर', value: subscribers.length, color: 'text-ink' },
    { label: 'सक्रिय', value: subscribers.filter((s) => s.active).length, color: 'text-green-600' },
    { label: 'निष्क्रिय', value: subscribers.filter((s) => !s.active).length, color: 'text-crimson' },
  ];

  return (
    <div>
      <h2 className="font-display text-2xl mb-5">सब्स्क्राइबरहरू</h2>
      <div className="grid grid-cols-3 gap-3.5 mb-6">
        {stats.map((s) => (
          <div key={s.label} className="bg-white border border-line rounded-[14px] p-4">
            <p className={`font-display text-[26px] font-bold leading-none mb-1 ${s.color}`}>{s.value}</p>
            <p className="text-[12.5px] font-semibold text-muted">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-2.5">
        {subscribers.map((s) => (
          <div key={s.id} className="flex items-center gap-3 bg-white border border-line rounded-xl p-3">
            <Mail size={20} className={`flex-shrink-0 ${s.active ? 'text-green-600' : 'text-muted'}`} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold truncate">{s.email}</p>
              <span className="text-xs text-muted">
                {s.active ? 'सक्रिय' : 'निष्क्रिय'} •{' '}
                {new Date(s.created_at).toLocaleDateString('ne-NP', { year: 'numeric', month: 'long', day: 'numeric' })}
              </span>
            </div>
            <div className="flex gap-1 flex-shrink-0">
              <button
                className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] hover:bg-paper-soft"
                onClick={() => handleToggleActive(s.email)}
                aria-label={s.active ? 'निष्क्रिय गर्नुहोस्' : 'सक्रिय गर्नुहोस्'}
              >
                {s.active ? <XCircle size={16} /> : <CheckCircle size={16} className="text-green-600" />}
              </button>
              <button className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] hover:bg-red-50 hover:text-crimson" onClick={() => handleDelete(s.email)} aria-label="Delete">
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
        {subscribers.length === 0 && <p className="text-muted py-4">कुनै सब्स्क्राइबर छैन।</p>}
      </div>
    </div>
  );
}

export default AdminSubscribers;